<div class="container-fluid">
    <h4 class="header-text">Διαχείριση Επιχειρήσεων</h4>

    <div class="search-form">
        <input id="gemiNumber" name="gemiNumber" class="search-input" formControlName="gemiNumber" (change)="handleChangeGemiNumber($event)" placeholder="Αρ. Γ.Ε.Μη"/> 
        <input id="am" name="am" class="search-input" formControlName="am" (change)="handleChangeAM($event)" placeholder="Α.M"/> 
        <input id="companyName" name="companyName" class="search-input" formControlName="companyName" (change)="handleChangeCompanyName($event)" placeholder="Όνομα Επιχείρησης"/> 
        <button class="search-button" (click)="searchCompanies()">Αναζήτηση</button>
    </div>
   
    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a (click)="tabNavigation($event)" class="nav-item nav-link" [ngClass]="{active:selectedTab === 'pending'}" id="pending-tab" data-toggle="tab" href="#content" role="tab" aria-controls="new-companies" aria-selected="true">Νέες Επιχειρήσεις</a>
            <a (click)="tabNavigation($event)" class="nav-item nav-link" [ngClass]="{active:selectedTab === 'approved'}" id="approved-tab" data-toggle="tab" href="#content" role="tab" aria-controls="nav-profile" aria-selected="false">Ενεργοποιημένες</a>
            <a (click)="tabNavigation($event)" class="nav-item nav-link" [ngClass]="{active:selectedTab === 'disapproved'}" id="disapproved-tab" data-toggle="tab" href="#content" role="tab" aria-controls="nav-contact" aria-selected="false">Απενεργοποιημένες</a>
        </div>
    </nav>

    <div class="tab-content" id="nav-tabContent" *ngIf="companiesData && companiesData.length!==0">
        <div class="tab-pane fade show active" id="content" role="tabpanel" aria-labelledby="nav-home-tab">
            <div class="row table-headings">
                <div class="col-md-2 col-lg-1">
                    Επιλογή Εταιρείας
                </div>
                <div class="col-md-2">
                    Όνομα Επιχείρησης
                </div>
                <div class="col-md-2">
                    Email - Αρ. ΓΕΜΗ - ΑΜ
                </div>
                
                <div class="col-md-2">
                    Ημερομηνία Δημιουργίας
                </div>
                <div class="col-md-2">
                    Προφιλ Επιχείρησης
                </div>
                <div class="col-md-2 col-lg-3">
                    Κατάσταση
                </div>
            </div>
            <div [id]="company.id" class="row my-rows" *ngFor="let company of companiesData">
                <div class="d-none d-block d-sm-block d-md-none col-6 pick small-screens-row-borders">
                    Επιλογή Εταιρείας
                </div>
                <div class="col-md-2 col-lg-1 col-6 small-screens-row-borders">
                    <input (change)="onPickOrUnpickCompany($event)" type="checkbox" [value]="company.id" name="companiesUuids">
                </div>
                <div class="d-none d-block d-sm-block d-md-none col-6 name small-screens-row-borders">
                    Όνομα Επιχείρησης
                </div>
                <div class="col-md-2 col-6 small-screens-row-borders">
                    {{company.name}}
                </div>

                <div class="d-none d-block d-sm-block d-md-none col-6 email small-screens-row-borders">
                    Email Επιχείρηση
                </div>
                <div class="col-md-2 col-12  small-screens-row-borders">
                    {{company.email}} - {{company.gemiId}}
                    <span *ngIf="company.am"> - {{company.am}}</span>
                </div>

                <div class="d-none d-block d-sm-block d-md-none col-6 email small-screens-row-borders">
                    Ημερομηνία Δημιουργίας
                </div>
                <div class="col-md-2 col-6 small-screens-row-borders">
                    {{company.creationDate | date}}
                </div>

                <div class="d-none d-block d-sm-block d-md-none col-6 info small-screens-row-borders">
                    Προφιλ Επιχείρησης
                </div>
                <div class="col-md-2 col-6 small-screens-row-borders">
                    <a class="links" (click)="moreDetails(company.id,company.activeJobPosts)">Περισσότερες Πληροφορίες</a>
                </div>

                <div class="d-none d-block d-sm-block d-md-none col-6 choices small-screen-last-row">
                    Κατάσταση
                </div>
                <div class="col-md-2 col-lg-3 col-6  small-screen-last-row">
                    <select id="{{'select'+company.id}}" (change)="changeActivationStatusOfOneCompany(company.id,$event)" name="sellist1" class="select-inputs" [ngClass]="{'pending-color': selectedTab === 'pending','approved-color':selectedTab === 'approved', 'disapproved-color': selectedTab === 'disapproved'}">
                            <option class="options-background-color" value="pending" [selected]="selectedTab === 'pending'">Εκκρεμής</option>
                            <option class="options-background-color" value="approved" [selected]="selectedTab === 'approved'">Εγκρίνεται</option>
                            <option class="options-background-color" value="disapproved" [selected]="selectedTab === 'disapproved'">Απορρίπτεται</option>
                        </select>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="companiesData && companiesData.length!==0" class="container button-container">
        <div class="row">
            <ng-template [ngIf]="selectedTab === 'pending'">
                <div class="col-md-4 col-12">
                    <button (click)="openConfirmModal('approved')" type="button" class="btn btn-success" style="width: 100%; font-size: 14px;">Έγκριση
                            επιλεγμένων</button>
                </div>
                <div class="col-md-4 offset-md-4 col-12">
                    <button (click)="openConfirmModal('disapproved')" type="button" class="btn btn-danger" style="width: 100%; font-size: 14px;">Απόρριψη
                            επιλεγμένων</button>
                </div>
            </ng-template>
            <ng-template [ngIf]="selectedTab === 'approved'">
                <div class="col-md-5 col-lg-4 col-md-auto col-12">
                    <button (click)="openConfirmModal('pending')" type="button" class="btn btn-warning" style="width: 100%; font-size: 14px;">Μεταφορά στις Εκρεμμότητες</button>
                </div>
                <div class="col-md-5 offset-md-2 col-lg-4 offset-lg-4 col-12">
                    <button (click)="openConfirmModal('disapproved')" type="button" class="btn btn-danger" style="width: 100%; font-size: 14px;">Απόρριψη
                            επιλεγμένων</button>
                </div>
            </ng-template>
            <ng-template [ngIf]="selectedTab === 'disapproved'">
                <div class="col-md-5 col-lg-4 col-md-auto col-12">
                    <button (click)="openConfirmModal('pending')" type="button" class="btn btn-warning" style="width: 100%; font-size: 14px;">Μεταφορά στις Εκρεμμότητες</button>
                </div>
                <div class="offset-md-2 col-md-5 offset-lg-4 col-lg-4 col-12">
                    <button (click)="openConfirmModal('approved')" type="button" class="btn btn-success" style="width: 100%; font-size: 14px;">Έγκριση
                            επιλεγμένων</button>
                </div>
            </ng-template>
        </div>
    </div>
    <!-- for not existing companies in a tab -->
    <p *ngIf="companiesData && companiesData.length === 0 && selectedTab === 'pending'">Δεν υπάρχουν εκκρεμείς επιχειρήσεις </p>
    <p *ngIf="companiesData && companiesData.length === 0 && selectedTab === 'approved'">Δεν υπάρχουν εγκεκριμένες επιχειρήσεις </p>
    <p *ngIf="companiesData && companiesData.length === 0 && selectedTab === 'disapproved'">Δεν υπάρχουν απορριφθείσες επιχειρήσεις</p>

    <!-- Pagination-->
    <app-pagination-bs *ngIf="resData" [initialPage]="currentPage + 1" [pageSize]="pageSize" [items]="resData" (changePage)="onChangePage($event)"></app-pagination-bs>

</div>

<!--MODAL for company profile data -->
<div id="more-details-modal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div *ngIf="companyData" class="modal-content container-fluid my-modal-content">
            <div class="layout-details">
                <div class="row">

                    <!-- company's logo -->
                    <div class="col-lg-3 col-md-2 col-sm-3 col-12 col-context">
                        <img *ngIf="companyData.logo" class="img-thumbnail company-logo" src="{{companyData.logo}}" alt="" />
                        <img *ngIf="!companyData.logo" class="img-thumbnail company-logo" src="assets/images/defaultcompanylogo.jpg" alt="" />
                    </div>

                    <!-- info -->
                    <div style="padding-top: 10px;" class="col-lg-6 col-md-6 col-sm-5 col-12 vertical-line">
                        <h5 class="context-break">{{companyData.name}}</h5>
                        <p class="p-margin" *ngIf="companyData && companyData.industryName">{{companyData.industryName}}</p>
                        <p *ngIf="companyData && companyData.locationName" class="p-margin context-break object-inline object-inline_sm"><span class="icon icon-1 mdi mdi-map-marker text-primary"></span><span>
                        {{companyData.locationName}}</span></p>
                        <p *ngIf="companyData.numberOfActiveJobPosts" class="p-margin object-inline object-inline_sm"><span class="icon icon-1 mdi mdi-file-document text-primary"></span><span>
                            {{companyData.numberOfActiveJobPosts}} Δημοσιευμένες Θέσεις</span></p>
                    </div>
                    <!-- social icons -->
                    <div class="col-lg-3 col-md-4 col-sm-4 col-12 col-context">
                        <ul style="text-align: center" class="list-inline list-inline-xs">
                            <li *ngIf="companyData.email">
                                <a class="icon icon-xxs icon-filled icon-filled-brand icon-circle fas fa-envelope" style="background: #ca5217; font-size: 16px;" href="mailto:{{companyData.email}}"></a>
                            </li>
                            <li *ngIf="companyData.facebookUrl">
                                <a style="background: #5776b7; font-size: 16px;" class="icon icon-xxs icon-filled icon-filled-brand icon-circle fa fa-facebook" href="{{companyData.facebookUrl}}"></a>
                            </li>
                            <li *ngIf="companyData.website">
                                <a style="background: #ca5217; font-size: 16px;" class="icon icon-xxs icon-filled icon-filled-brand icon-circle mdi mdi-web" href="{{companyData.website}}"></a>
                            </li>
                            <li *ngIf="companyData.linkedInUrl">
                                <a class="icon icon-xxs icon-filled icon-filled-brand icon-circle fa fa-linkedin" style="color:white; background: #5776b7; font-size: 16px;" href="{{companyData.linkedInUrl}}"></a>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>

            <h4 *ngIf="companyData.description || companyData.motto || companyData.numberEmployees || companyData.yeaFfounded" class="heading-decorated_1">Σχετικά με την Εταιρεία</h4>

            <p id="descriptionParagraph" class="text-style-1" [innerHtml]="companyData.description | safe"></p>
            <br/>
            <span *ngIf="companyData.motto"><span style="color: black;">Μotto Εταιρείας:</span> {{companyData.motto}}</span>
            <br/>
            <span *ngIf="companyData.numberEmployees"><span style="color:black;"> Αριθμός εργαζομένων:</span> {{companyData.numberEmployees}}</span>
            <br/>
            <!-- <span *ngIf="companyData.yearFounded"><span style="color:black;">Έτος Ίδρυσης εταιρείας:</span> {{companyData.yearFounded}}</span>
            <br/> -->

        </div>
    </div>
</div>

<!-- MODAL for confirm action-->
<div id="confirm-modal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{modalTitle}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body">
                <p>{{modalMessage}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Ακύρωση</button>
                <button type="button" class="btn btn-primary" (click)="changeActivationStatusOfMultipleCompanies(selectedStatusForMultipleCompanies)">Επιβεβαίωση</button>
            </div>
        </div>
    </div>
</div>